<template>
  <withTopNav leftText="Depósito" class="text-13" :onClickLeft="navigateHome" fixed>
    <div class="depositorResults flex flex-col h-full">
      <div class="w-full h-full flex-1 flex flex-col items-center text-white">
        <template v-if="status === 'Paying'">
          <van-loading class="mt-[80px]" />
          <span class="text-[12px] leading-[14px] text-[#95979b] mt-[45px]">
            {{ $t('DepositoResults.OrderNumber') }}
          </span>
          <span class="text-[12px] leading-[14px] text-[#95979b]">
            {{ searchParams.orderNo }}
          </span>
          <div class="text-[20px] mt-[15px] mb-[10px]">{{ $t('DepositoResults.OrderQuery') }}</div>
          <div class="text-[14px] text-center px-[60px] leading-[16px]">
            {{ $t('DepositoResults.WaitingForResults') }}
          </div>
        </template>
        <template v-else-if="status === 'TryAgain'">
          <Image class="w-[200px] h-[100px] mt-[80px]" :src="overtime" alt="" />
          <span class="text-[12px] leading-[14px] text-[#95979b] mt-[45px]">
            {{ $t('DepositoResults.OrderNumber') }}
          </span>
          <span class="text-[12px] leading-[14px] text-[#95979b]">
            {{ searchParams.orderNo }}
          </span>
          <div class="text-[15px] mt-[15px] mb-[10px]">{{ $t('DepositoResults.NoResults') }}</div>
          <div class="text-[12px] text-center px-[50px] leading-[16px]">
            {{ $t('DepositoResults.TryAgainMessage') }}
          </div>
          <button
            @click="retryQuery"
            class="w-[356px] h-[44px] text-[15px] text-[#2F1780] font-bold rounded-[8px] bg-[#64F765] mt-[30px]"
          >
            {{ $t('DepositoResults.RetryQuery') }}
          </button>
        </template>
        <template v-else-if="status === 'Paid' || status === 'ForcedSuccess'">
          <Image class="size-[58px] mt-[80px]" :src="success" alt="" />
          <span class="text-[#64F765] text-[25px] font-bold mt-[20px]">
            {{ $t('DepositoResults.Amount') }} {{ formatter().format(amount) }}
          </span>
          <span class="text-[12px] leading-[14px] text-[#95979b]">
            {{ $t('DepositoResults.OrderNumber') }}
          </span>
          <span class="text-[12px] leading-[14px] text-[#95979b]">
            {{ searchParams.orderNo }}
          </span>
          <div class="text-[20px] mt-[15px] mb-[10px]">{{ $t('DepositoResults.DepositSuccessful') }}</div>
          <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
            {{ $t('DepositoResults.ReturnToHomeMessage') }}
          </div>
          <button
            @click="navigateHome"
            class="w-[356px] h-[44px] text-[15px] text-[#151A1F] font-bold rounded-[8px] bg-[#64F765] mt-[30px]"
          >
            {{ $t('DepositoResults.ReturnToHome') }}
          </button>
        </template>
        <template v-else-if="status === 'PayFailed'">
          <Image class="size-[58px] mt-[80px]" :src="fail" alt="" />
          <span class="text-[#64F765] text-[25px] font-bold mt-[20px]">
            {{ $t('DepositoResults.Amount') }} {{ formatter().format(amount) }}
          </span>
          <span class="text-[12px] leading-[14px] text-[#95979b]">
            {{ $t('DepositoResults.OrderNumber') }}
          </span>
          <span class="text-[12px] leading-[14px] text-[#95979b]">
            {{ searchParams.orderNo }}
          </span>
          <div class="text-[20px] mt-[15px] mb-[10px]">{{ $t('DepositoResults.DepositFailed') }}</div>
          <div class="text-[14px] text-center px-[50px] leading-[16px] text-white/70">
            {{ $t('DepositoResults.ReturnToHomeMessage') }}
          </div>
          <button
            @click="navigateHome"
            class="w-[356px] h-[44px] text-[15px] text-[#151A1F] font-bold rounded-[8px] bg-[#64F765] mt-[30px]"
          >
            {{ $t('DepositoResults.ReturnToHome') }}
          </button>
        </template>
      </div>
    </div>
  </withTopNav>
</template>

<script setup lang="ts">
import overtime from "@/themes/theme_a/views/DepositoResults/images/overtime.png";
import success from "@/themes/theme_a/views/DepositoResults/images/success.png";
import fail from "@/themes/theme_a/views/DepositoResults/images/fail.png";
import withTopNav from "@/layouts/withTopNav.vue";
import { formatter } from "@/utils";
import { checkingOrder } from "@/api/deposito";
import { useActivityList, useWallet } from "@/store";
import useTrack from "@/hooks/useTrack";

const { track2Platform, trackName } = useTrack();
const route = useRoute();
const router = useRouter();
const status = ref("Paying");
const amount = ref<any>(0);
const searchParams = ref(route.query);
const orderNo = ref(searchParams.value.orderNo);
const maxRetries = 4;
let attempt = 0;
let tid

onMounted(() => {
  if (searchParams.value.status == "PullFailed") {
    status.value = "PayFailed";
    amount.value = searchParams.value.amount;
  } else {
    clearInterval(tid)
    queryOrderState();
  }
});

let flag = false
const queryOrderState = async () => {
  try {
    const res = await checkingOrder({ orderNo: orderNo.value });
    console.log(res, attempt);

    if (res?.data?.firstFlag) {
      // 首充
      track2Platform(trackName.Purchase, {
        value: +amount.value,
        currency: res.data.currency,
        product_catalog_id: res.data.id,
      });
    }

    if (res?.data?.status === "ForcedSuccess" || res?.data?.status === "Paid" || res?.data?.status === "PayFailed") {
      amount.value = res?.data?.realAmt;
      status.value = res?.data?.status;
      
      if (res?.data?.status !== "PayFailed") {
        useWallet().init();
      }
    }

    if (res?.data?.status === "ForcedSuccess" || res?.data?.status === "Paid") {
      flag = true
      return
    }

    if (attempt === 3) {
      status.value = "TryAgain";
    }
  } catch (error) {
    if (attempt === 3) {
      status.value = "TryAgain";
    }
    if (attempt >= maxRetries) {
      throw error;
    }
  } finally {
    if (flag) return

    attempt++;
    if (attempt < maxRetries) {
      tid = setTimeout(() => {
        queryOrderState();
      }, 3000);
    }
  }
};
// 重试查询
const retryQuery = async () => {
  status.value = "Paying";
  clearInterval(tid)
  queryOrderState();
};
//
const navigateHome = () => {
  router.push("/");
  if (status.value === "Paid") {
    setTimeout(() => {
      useActivityList().init();
    }, 20000);
  }
};
</script>

<style scoped></style>
